// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6owEW","newExpiryDate":"styles_newExpiryDate__2apSA","footer":"styles_footer__3pJ22"};